import { useStore } from '@/core/store';

export default function useActionPromo (locationId, paid, experiences, bookingStationTimes, editBookingStationTime) {
  const store = useStore();

  function couponAction (coupon, bookingStationTimeId) {
    const bookingStationTime = bookingStationTimes.value.find(bookingStationTime => bookingStationTime._id === bookingStationTimeId);
    if (bookingStationTime.coupon && bookingStationTime.coupon.id === coupon.id) coupon = {};
    editBookingStationTime(bookingStationTimeId, 'coupon', { id: coupon.id });
    refreshPromos();
  }

  function discountAction (discount, bookingStationTimeId) {
    const bookingStationTime = bookingStationTimes.value.find(bookingStationTime => bookingStationTime._id === bookingStationTimeId);
    if (bookingStationTime.discount && bookingStationTime.discount.id === discount.id) discount = {};
    editBookingStationTime(bookingStationTimeId, 'discount', { id: discount.id });
    refreshPromos();
  }

  function refreshPromos () {
    bookingStationTimes.value.forEach(bookingStationTime => {
      const experience = experiences.value.find(experience => experience.id === bookingStationTime.experience.id);
      const price = store.getters.tierPriceToLocationPrice({ locationId, tierPrice: bookingStationTime.tier.price });

      let savings = 0;

      if (bookingStationTime.coupon) {
        const coupon = experience.coupons.find(experienceCoupon => experienceCoupon.id === bookingStationTime.coupon.id);

        if (coupon) {
          if (coupon.type === 'percent') {
            savings += Math.round((price * (coupon.amount / 100)));
          } else {
            savings += coupon.amount;
          }
        }
      }

      if (bookingStationTime.discount) {
        const discount = experience.discounts.find(experienceDiscount => experienceDiscount.id === bookingStationTime.discount.id);

        if (discount) {
          if (discount.type === 'percent') {
            savings += Math.round((price * (discount.amount / 100)));
          } else {
            savings += discount.amount;
          }
        }
      }

      let newPrice = price - savings;
      if (newPrice < 0) newPrice = 0;

      if (paid.value) {
        editBookingStationTime(bookingStationTime._id, 'amountPaid', newPrice);
      } else {
        editBookingStationTime(bookingStationTime._id, 'amountDue', newPrice);
      }
    });
  }

  return {
    couponAction,
    discountAction,
  };
}
